import { applyMiddleware, combineReducers, createStore } from 'redux';
import createSagaMiddleware from 'redux-saga';
import createHistory from 'history/createBrowserHistory';
import { routerMiddleware, routerReducer } from 'react-router-redux';
import { getAsyncReducers, setSagaMiddleware } from 'react-async-client';
import * as compose from "ramda/src/compose";
import { persistStore, persistReducer } from 'redux-persist';
import storage from 'redux-persist/es/storage';

import rootReducer from './reducers/rootReducer';
import rootSaga from './sagas/rootSaga';

const sagaMiddleware = createSagaMiddleware();
setSagaMiddleware(sagaMiddleware);

export const history = createHistory();

let middlewares = [
    sagaMiddleware,
    routerMiddleware(history)
];

if (process.env.NODE_ENV !== 'production') {
    const createLogger = require('redux-logger').createLogger;
    const logger = createLogger({collapsed: true});
    middlewares.push(logger);
}

let composeEnhancers = compose;

if (process.env.NODE_ENV === 'development') {
    if (window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__) {
        composeEnhancers = window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__({})
    }
}

const persistConfig = {
    key: 'legrand',
    storage,
    whitelist: [
        'token'
    ]
};

function configureStore(initialState) {
    const reducer = persistReducer(persistConfig, combineReducers({
        routing: routerReducer,
        ...getAsyncReducers(),
        ...rootReducer
    }));

    const Store = createStore(
        reducer,
        initialState,
        composeEnhancers(applyMiddleware(...middlewares))
    );
    const Persistor = persistStore(Store);

    sagaMiddleware.run(rootSaga);

    return { Store, Persistor };
}

export const { Store, Persistor } = configureStore();



// WEBPACK FOOTER //
// ./src/store.js